import CloseIcon from '@mui/icons-material/Close';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import PropTypes from 'prop-types';
import React, {useCallback} from 'react';
import {
  IconButton,
  InputAdornment,
  TextField as MUITextField,
} from '@mui/material';

const FilterTextField = ({
  value: valueProp,
  onChange,
  clearable,
  InputProps,
  ...props
}) => {
  const handleOnChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleOnClear = () => {
    onChange('');
  };

  return (
    <MUITextField
      value={valueProp}
      onChange={handleOnChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FilterAltOutlinedIcon />
          </InputAdornment>
        ),
        endAdornment: valueProp && clearable && (
          <InputAdornment position="end">
            <IconButton onClick={handleOnClear}>
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  );
};

FilterTextField.propTypes = {
  clearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  InputProps: PropTypes.object,
};

FilterTextField.defaultProps = {
  clearable: true,
  placeholder: 'Filter',
};

export default FilterTextField;
